import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  checkCanClaimOneTimeOffer: {
    method: 'GET',
    url: `${configs.baseUrl}/api/pricing/check-can-claim-free-one-time`,
  },
  claimOneTimeOffer: {
    method: 'POST',
    url: `${configs.baseUrl}/api/pricing/claim-free-one-time`,
  },
  declineOneTimeOffer: {
    method: 'POST',
    url: `${configs.baseUrl}/api/pricing/decline-free-one-time`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const claimOneTimeOffer = async (payload) => {
  const res = await resource.claimOneTimeOffer(payload)
  return res.body
}
const declineOneTimeOffer = async (payload) => {
  const res = await resource.declineOneTimeOffer(payload)
  return res.body
}
const checkCanClaimOneTimeOffer = async (payload) => {
  const res = await resource.checkCanClaimOneTimeOffer(payload)
  return res.body
}

export default {
  initResource,
  claimOneTimeOffer,
  declineOneTimeOffer,
  checkCanClaimOneTimeOffer,
}
